module.exports = "/images/6.png?adf7e5ccf8b16df469bd73be34c37013";